import React from 'react';
import {StepProps, asRecord, stringField} from './types';

/**
 * Шаг «Размеры» (слот 5). Справочника размеров в продукте нет — храним свободный текст,
 * как его пишут на бирках; при завершении мастера ответ целиком уезжает в
 * `UserSettings.sizesJson`.
 */
const SIZE_FIELDS: {field: string; label: string; placeholder: string}[] = [
    {field: 'top', label: 'Верх', placeholder: 'M / 48 / EU 40'},
    {field: 'bottom', label: 'Низ', placeholder: '31/32 / 48'},
    {field: 'shoes', label: 'Обувь', placeholder: '41 EU'},
];

const StepSizes: React.FC<StepProps> = ({value, onChange}) => {
    const current = asRecord(value);

    const update = (field: string, raw: string) => {
        const next = {...current};
        const trimmed = raw.trim();
        if (trimmed === '') {
            delete next[field];
        } else {
            next[field] = raw;
        }
        onChange(next);
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="onboarding-step-sizes">
            {SIZE_FIELDS.map(f => (
                <label key={f.field} className="flex flex-col gap-1">
                    <span className="text-sm text-gray-700 dark:text-gray-300">{f.label}</span>
                    <input
                        type="text"
                        maxLength={32}
                        value={stringField(value, f.field)}
                        onChange={e => update(f.field, e.target.value)}
                        className="input-field min-h-[44px]"
                        placeholder={f.placeholder}
                        data-testid={`onboarding-size-${f.field}`}
                    />
                </label>
            ))}
        </div>
    );
};

export default StepSizes;
